module.exports = __webpack_public_path__ + "static/media/contact-light.1f770f0f.5f1aae0a.svg";